module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/advantages_2_4-21b84d7ff5b7663f4934347155412f5e.png";